import { Directive, HostListener, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { MatDialogContainer, MatDialogRef } from '@angular/material';
import { Subscription, Observable, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';



@Directive({
  selector: '[resize-dialog-directive]'
})
export class ResizeDirective implements OnInit {

  private _subscription: Subscription;

  mouseStart: Position;

  mouseDelta: Position;

  offset: Position;

  constructor(
    private matDialogRef: MatDialogRef<any>,
    private container: MatDialogContainer, private el: ElementRef, private renderer: Renderer2) {
      
    }

  ngOnInit() {
    this.offset = this._getOffset();

    /* TODO: fix all subseqeunt resizes after the first one */
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {

    this.offset = this._getOffset();

    this.mouseStart = {x: event.pageX, y: event.pageY};

    const mouseup$ = fromEvent(document, 'mouseup');
    this._subscription = mouseup$.subscribe(() => this.onMouseup());

    const mousemove$ = fromEvent(document, 'mousemove')
      .pipe(takeUntil(mouseup$))
      .subscribe((e: MouseEvent) => this.onMouseMove(e));

    this._subscription.add(mousemove$);
  }

  onMouseMove(event: MouseEvent) {
      this.mouseDelta = {x: (event.pageX - this.mouseStart.x), y: (event.pageY - this.mouseStart.y)};

      this._updatePosition(-this.mouseDelta.y, -this.mouseDelta.x);
  }

  onMouseup() {
    if (this._subscription) {
      this._subscription.unsubscribe();
      this._subscription = undefined;
    }

    if (this.mouseDelta) {
      this.offset.x += this.mouseDelta.x;
      this.offset.y += this.mouseDelta.y;
    }

    
  }

  private _updatePosition(top: number, left: number) {

    console.log('hit', this.offset)

    if (this.offset.x < 0)
    this.offset.x = this.offset.x*-1;
  if(this.offset.y < 0)
    this.offset.y = this.offset.y*-1;
    
    this.matDialogRef.updateSize(this.offset.x + left + "px", this.offset.y + top + "px");

    console.log('component instance', document.getElementById('chart'))

    this.renderer.setStyle(document.getElementById('chart-parent'), 'height', this.offset.y -100 + "px")

    
  }

  private _getOffset(): Position {
    const box = this.container['_elementRef'].nativeElement.getBoundingClientRect();
    return {
      x: box.width,
      y: box.height
    };
  }
}


export interface Position {
  x: number;
  y: number;
}